import React from 'react'
import clsx from 'clsx'
import { Checkbox } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import Autocomplete from '@material-ui/lab/Autocomplete'
import CheckBoxOutlineBlankIcon from 'components/material-symbol/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from 'components/material-symbol/icons/CheckBox'
import match from 'autosuggest-highlight-with-opts/match'
import parse from 'autosuggest-highlight-with-opts/parse'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon color="primary" fontSize="small" />

const useStyles = makeStyles(theme => ({
  optionIcon: {
    marginRight: theme.spacing(1),
  },

  suggestion: {
    fontWeight: 700,
  },
}))

export default function AutocompleteMultiselect({ getOptionLabel, ...rest }) {
  const classes = useStyles()

  return (
    <Autocomplete
      {...rest}
      multiple
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      renderOption={(option, { inputValue, selected }) => {
        const label = getOptionLabel(option)
        const matches = match(label, inputValue, { insideWords: true })
        const parts = parse(label, matches)
        const trimmedInput = inputValue.trim()

        return (
          <>
            <Checkbox
              className={classes.optionIcon}
              icon={icon}
              checkedIcon={checkedIcon}
              checked={selected}
            />

            <div>
              {parts.map((part, i) => (
                <span
                  key={i}
                  className={clsx({
                    [classes.suggestion]: trimmedInput && !part.highlight,
                  })}
                >
                  {part.text}
                </span>
              ))}
            </div>
          </>
        )
      }}
    />
  )
}
